export default __webpack_public_path__ + "static/media/2008.24e5ba26.png";